import { t } from 'i18next';
import React, { useEffect, useCallback } from 'react';
import $ from 'jquery';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { allService } from '../services';
import { useSelector } from 'react-redux';
import toast, { Toaster } from 'react-hot-toast';
import _ from 'lodash';
import { Pagination } from 'react-headless-pagination';
import { logOut } from '../actions';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import TableLoader from '../components/common/Squeletontable';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

export default function Dashboard() {
  // Declaration of project constant
  const user = useSelector((state) => state.user);
  const isAuthenticated = useSelector((state) => state.connection);
  const [lang, setLang] = useState('Fr');
  const [count, setCount] = useState(0);
  const [count1, setcount1] = useState(0);
  const { t, i18n } = useTranslation();
  const token = useSelector((state) => state.token);
  const [filteredAllData, setFilteredData] = useState([]);
  const [filteredAllData1, setFilteredData1] = useState([]);
  const [paginatedData, setPaginatedData] = useState([]);
  const [dataTransaction, setDataTransaction] = useState([]);
  const [pages, setPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [tableLoader, displayTableLoader] = useState(true);
  const [addBundleForm, displayAddBundleForm] = useState(false);
  const [setting, showSetting] = useState(false);
  const [updateBundleForm, displayUpdateBundleForm] = useState(false);
  const [updateTransacForm, displayUpdateTransacForm] = useState(false);
  const [operators, setOperator] = useState([]);
  const [operatorsCopy, setOperatorCopy] = useState([]);
  const [bundles, setBundle] = useState([]);
  const [bundleCopy, setBundleCopy] = useState([]);
  const [newBundle, setNewBundle] = useState({
    operator: '',
    operator_id: '',
    operator_code: '',
    code: '',
    name: '',
    price: '',
    description: '',
    active: 0,
  });
  const [bundleToUpdate, setbundleToUpdate] = useState({
    operator: '',
    operator_id: '',
    operator_code: '',
    code: '',
    name: '',
    price: '',
    description: '',
    active: '',
  });
  const [transacToUpdate, setTransacToUpdate] = useState([]);
  const [error, setError] = useState('');
  const [tab, setTab] = useState({ operators: false, bundles: true });
  const [load, setLoad] = useState(false);
  const [modalLoader, setModalLoader] = useState(false);
  const [loadUpdate] = useState(false);
  const [clear, setclear] = useState('');
  const [clear1, setclear1] = useState('');
  const history = useHistory();
  const dispatch = useDispatch();
  const [pageIndex, setPageIndex] = useState(1);
  const [dataAnalysis, setDataAnalysis] = useState([]);
  const TransactionCount = [
    { label: `10  ${t('transaction')}`, value: 10 },
    { label: `50  ${t('transactions')}`, value: 50 },
    { label: `100  ${t('transactions')}`, value: 100 },
    { label: `200  ${t('transactions')}`, value: 200 },
    { label: ` ${t('Show_all')}`, value: 'all' },
  ];
  const TransactionStatus = [
    { label: t('Completed'), value: 'COMPLETED' },
    { label: t('In_progress'), value: 'PENDING' },
    { label: t('Failed_trans'), value: 'FAILED' },
    { label: t('New'), value: 'NEW' },
    { label: t('Show_all'), value: 'all' },
  ];
  const [loadGlobalStat, setLoadGlobalStat] = useState(false);
  var date = new Date();
  var year = date.toLocaleString('default', { year: 'numeric' });
  var month = date.toLocaleString('default', { month: '2-digit' });
  var day = date.toLocaleString('default', { day: '2-digit' });
  var formattedDate = year + '-' + month + '-' + day;
  const [enteredDate, setenteredDate] = useState(formattedDate);
  const [weeklydata, setweeklyData] = useState([]);

  const options = {
    title: {
      text: 'Glotelho Pay Analysis ',
    },
    xAxis: {
      categories: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ],
      lotBands: [
        {
          from: 4.5,
          to: 6.5,
          color: 'rgba(68, 170, 213, .2)',
        },
      ],
    },
    series: [
      {
        data: dataAnalysis,
      },
    ],
  };

  const weekly = {
    title: {
      text: `Glotelho Pay  Daily analysis form the  ${enteredDate} `,
    },
    xAxis: {
      categories: weeklydata.days,
      lotBands: [
        {
          from: 4.5,
          to: 6.5,
          color: 'rgba(68, 170, 213, .2)',
        },
      ],
    },
    yAxis: {
      gridLineColor: 'rgba(68, 170, 213, .2)',
      title: {
        text: ' Amount Sold',
      },
    },
    series: [
      {
        data: weeklydata.amounts,
        name: 'Amount Sold',
      },
    ],
  };

  useEffect(() => {
    getweeklyAnalysis();
  }, [enteredDate]);

  function getweeklyAnalysis() {
    setLoadGlobalStat(true);
    allService
      .getAll(`admin/statistique/days/${enteredDate}/transactions`, token)
      .then((d) => {
        setweeklyData(d);
        setLoadGlobalStat(false);
      })

      .catch((e) => {});
  }

  //Method use to set pagination data
  const pagination = (event) => {
    setCurrentPage(event);
    setPageIndex(event + 1);
    const startIndex = event * pageSize;
    const paginateD = _(filteredAllData)
      .slice(startIndex)
      .take(pageSize)
      .value();
    setPaginatedData(paginateD);
  };

  //Function use to update paginate data when data array has been updated
  const updatePagination = (data) => {
    setFilteredData(data);
    setPaginatedData(_(data).slice(0).take(pageSize).value());
    //setPages(_.range(1, Math.ceil(data.length / pageSize) + 1));
    setPages(Math.ceil(data.length / pageSize));
  };

  //Function to use to handle language choice
  const changeLanguageHandler = (l) => {
    i18n.changeLanguage(l.toLowerCase());
    setLang(l);
  };

  //Method use to research by status
  const handleStatus = (param) => {
    const f = filteredAllData.filter((d) => {
      if (param !== 'all' && d.status === param) return d;
      if (param === 'all') {
        return d;
      }
    });
    setPaginatedData(_(f).slice(0).take(count).value());
    setcount1(_(f).slice(0).value());
    setPages(Math.ceil(f.length / pageSize));
    // setCurrentPage(1);
    setCount(f.length);
    setclear('');
  };

  //Method use to research by number users
  const handleNumberFilter = (param) => {
    let count;
    if (param === 'all') {
      count = filteredAllData.length;
    } else {
      count = param;
    }
    setPaginatedData(_(filteredAllData).slice(0).take(count).value());
    setPages(Math.ceil(filteredAllData.length / count));
    setPageSize(param);
    //  setCurrentPage(1);
    setclear('');
    setPageIndex(1);
  };

  //Method use to research array by payer_number , type, uuid, type and receiver_phone
  const handleFilter = (e) => {
    const f = filteredAllData.filter((d) => {
      if (e.target.value === '') return d;
      if (
        d.payer_number
          .toLowerCase()
          .trim()
          .includes(e.target.value.toLowerCase().trim())
      )
        return d;
      if (
        d.status
          .toLowerCase()
          .trim()
          .includes(e.target.value.toLowerCase().trim())
      )
        return d;
      if (
        d.type
          .toLowerCase()
          .trim()
          .includes(e.target.value.toLowerCase().trim())
      )
        return d;
      if (
        d.receiver_number
          .toLowerCase()
          .trim()
          .includes(e.target.value.toLowerCase().trim())
      )
        return d;
      if (
        d.uuid
          .toLowerCase()
          .trim()
          .includes(e.target.value.toLowerCase().trim())
      )
        return d;
      if (
        d.payer_network
          .toLowerCase()
          .trim()
          .includes(e.target.value.toLowerCase().trim())
      )
        return d;
    });
    setPaginatedData(_(f).slice(0).take(count).value());
    setcount1(_(f).slice(0).value());
    setPages(Math.ceil(f.length / pageSize));
    // setCurrentPage(1);
    setCount(f.length);
    setclear(e.target.value);
  };

  const handleFilter1 = (e) => {
    const f = filteredAllData1.filter((d) => {
      if (e.target.value === '') return d;
      if (
        d.code
          .toLowerCase()
          .trim()
          .includes(e.target.value.toLowerCase().trim())
      )
        return d;
      if (
        d.operator
          .toLowerCase()
          .trim()
          .includes(e.target.value.toLowerCase().trim())
      )
        return d;
      if (
        d.description
          .toLowerCase()
          .trim()
          .includes(e.target.value.toLowerCase().trim())
      )
        return d;
    });
    setBundleCopy(_(f).slice(0).take(pageSize).value());
    setclear1(e.target.value);
  };

  //Method use to research by status
  const handleStatus1 = (param) => {
    const f = filteredAllData1.filter((d) => {
      if (param !== 'all' && d.operator === param) return d;
      if (param === 'all') return d;
    });
    setclear1('');
    setBundleCopy(_(f).slice(0).take(pageSize).value());
  };

  //for all operators (MTN,ORANGE and CAMTEL)
  const operatorStatus = [
    { label: 'ORANGE', value: 'ORANGE' },
    { label: 'MTN', value: 'MTN' },
    { label: 'CAMTEL', value: 'CAMTEL' },
    { label: t('Show_all'), value: 'all' },
  ];

  const disconnect = () => {
    dispatch(logOut());
    history.push('/login');
  };

  //Method use to get all data from server
  const getData = useCallback(
    (isRefreshAction) => {
      displayTableLoader(true);
      allService
        .getAll('admin/transactions', token)
        .then((d) => {
          setDataTransaction(d.data);
          setFilteredData(d.data);
          setCount(d.data.length);
          setcount1(d.data);
          console.log(d.data);
          setPaginatedData(_(d.data).slice(0).take(pageSize).value());
          setPages(Math.ceil(d.data.length / pageSize));
          displayTableLoader(false);
          if (isRefreshAction) {
            toast.success(t('List_updated'), {
              style: {
                padding: '16px',
                color: '#fff',
                background: '#02274a',
                borderRadius: '10px',
              },
              iconTheme: {
                primary: '#229954',
                secondary: '#FFFAEE',
              },
            });
          }
        })
        .catch((e) => {
          displayTableLoader(false);
          toast.error(
            t('Failed_to_connect'),
            {
              style: {
                padding: '16px',
                color: '#fff',
                borderRadius: '10px',
                background: '#02274a',
              },
              iconTheme: {
                primary: '#FF0033',
                secondary: '#FFFAEE',
              },
            },
            {
              duration: 10000,
            },
          );
        });
    },
    [token],
  );

  function getOperatorData() {
    allService
      .getAll('operators/list/', token)
      .then((operator) => {
        setOperator(operator);
        setOperatorCopy(operator);
        setNewBundle({
          operator: operator[0].name,
          operator_id: operator[0].id,
          operator_code: operator[0].code,
          code: '',
          name: '',
          price: '',
          description: '',
        });
      })
      .catch((e) => {});
  }

  function getBundleData() {
    allService
      .getAll('bundles/list/', token)
      .then((bundle) => {
        setBundle(bundle);
        setFilteredData1(bundle);
        setBundleCopy(bundle);
      })
      .catch((e) => {});
  }

  // functions to perform side effects
  useEffect(() => {
    getData(false);
    getOperatorData();
    getBundleData();
  }, []);

  useEffect(() => {
    setting ? $('.modal-setting').fadeIn() : $('.modal-setting').fadeOut();
  }, [setting]);

  useEffect(() => {
    updateTransacForm
      ? $('.modal-transac').fadeIn()
      : $('.modal-transac').fadeOut();
  }, [updateTransacForm]);

  const handleClickTab = (action) => {
    if (action === 'OPERATOR') {
      setTab({ operators: true, bundles: false });
    } else if (action === 'BUNDLE') {
      setTab({ operators: false, bundles: true });
    }
  };

  const updateStateCopy = (
    item,
    stateName,
    stateAction,
    updatingPagination,
  ) => {
    var list = [...stateName];
    const newEl = list.map((el) => {
      if (el.id === item.id) {
        el = item;
      }
      return el;
    });
    stateAction(newEl);
    if (updatingPagination) {
      updatePagination(newEl);
    }
  };

  const handleUpdateOperatorTitle = (e, operator) => {
    var val = e.target.value;
    var element = operatorsCopy.find((ele) => ele.id === operator.id);
    element = {
      id: operator.id,
      name: val,
      code: element.code,
      image: element.image,
      can_topup: element.can_topup,
      can_activate_bundles: element.can_activate_bundles,
      active: element.active,
      Bundles_count: element.Bundles_count,
    };

    updateStateCopy(element, operatorsCopy, setOperatorCopy, false);
  };

  function handleUpdatedOperatorTitle(e, operator) {
    const dataToStore = {
      id: operator.id,
      code: operator.code,
      name: e.target.value,
    };

    var found = operators.find(
      (element) =>
        element.id === operator.id && element.name !== e.target.value,
    );
    if (found) {
      updateOperatorData(dataToStore);
    }
  }

  async function handleUpdatedOperatorActivation(operator, e) {
    var action = e.target.name;
    var value = e.target.checked;
    var dataToStore = {};

    if (action === 'TOPUP') {
      dataToStore = {
        id: operator.id,
        name: operator.name,
        code: operator.code,
        can_topup: value ? 1 : 0,
      };
    } else if (action === 'BUNDLE') {
      dataToStore = {
        id: operator.id,
        name: operator.name,
        code: operator.code,
        can_activate_bundles: value ? 1 : 0,
      };
    }

    var found = operators.find((element) => element.id === operator.id);
    if (found) {
      updateOperatorData(dataToStore);
    }
  }

  async function updateOperatorData(data) {
    setModalLoader(true);
    return allService
      .update(data.id, data, `admin/operators`, 'update', token)
      .then((serverData) => {
        setModalLoader(false);
        updateStateCopy(
          serverData.data.operator,
          operators,
          setOperator,
          false,
        );
        updateStateCopy(
          serverData.data.operator,
          operatorsCopy,
          setOperatorCopy,
          false,
        );
        toast.success(
          t('Operator_updated'),
          {
            style: {
              padding: '16px',
              color: '#fff',
              borderRadius: '10px',
              background: '#02274a',
            },
            iconTheme: {
              primary: '#229954',
              secondary: '#FFFAEE',
            },
          },
          {
            duration: 10000,
          },
        );
      })
      .catch((e) => {
        setModalLoader(false);
        var found = operators.find((element) => element.id === data.id);
        updateStateCopy(found, operators, setOperator, false);
        updateStateCopy(found, operatorsCopy, setOperatorCopy, false);
        toast.error(
          t('A_server_error'),
          {
            style: {
              padding: '16px',
              color: '#fff',
              borderRadius: '10px',
              background: '#02274a',
            },
            iconTheme: {
              primary: '#FF0033',
              secondary: '#FFFAEE',
            },
          },
          {
            duration: 10000,
          },
        );
      });
  }

  const handleUpdateBundleData = (e, bundle) => {
    var val = e.target.value;
    var inputName = e.target.name;
    var element = bundleCopy.find((ele) => ele.id === bundle.id);
    element = {
      id: bundle.id,
      name: inputName === 'name' ? val : element.name,
      code: element.code,
      price: inputName === 'price' ? val : element.price,
      active: element.active,
      operator_id: element.operator_id,
      operator: element.operator,
      description: element.description,
      created_at: element.created_at,
      updated_at: element.updated_at,
    };
    updateStateCopy(element, bundleCopy, setBundleCopy, false);
  };

  async function handleUpdatedBundleData(e, bundle, isForm) {
    e.preventDefault();
    var inputName = e.target.name;
    var dataToStore = {};
    var found = null;
    if (!isForm) {
      if (inputName === 'name') {
        dataToStore = {
          id: bundle.id,
          code: bundle.code,
          name: e.target.value,
          price: bundle.price,
          operator_id: bundle.operator_id,
          operator_code: bundle.operator,
        };
        found = bundles.find(
          (element) =>
            element.id === bundle.id && element.name !== e.target.value,
        );
      } else if (inputName === 'price') {
        dataToStore = {
          id: bundle.id,
          code: bundle.code,
          name: bundle.name,
          price: e.target.value,
          operator_id: bundle.operator_id,
          operator_code: bundle.operator,
        };
        found = bundles.find(
          (element) =>
            element.id === bundle.id && element.price !== e.target.value,
        );
      }

      if (found) {
        updateBundleData(dataToStore);
      }
    } else {
      dataToStore = {
        id: bundleToUpdate.id,
        code: bundleToUpdate.code,
        name: bundleToUpdate.name,
        price: bundleToUpdate.price,
        description: bundleToUpdate.description,
        operator_id: bundleToUpdate.operator_id,
        operator_code: bundleToUpdate.operator,
        active: bundleToUpdate.active,
      };
      updateBundleData(dataToStore);
    }
  }

  async function handleUpdatedBundleActivation(bundle, e) {
    var value = e.target.checked ? 1 : 0;
    var dataToStore = {
      id: bundle.id,
      code: bundle.code,
      name: bundle.name,
      price: bundle.price,
      operator_id: bundle.operator_id,
      operator_code: bundle.operator,
      description: bundle.description,
      active: value,
    };

    var found = bundles.find((element) => element.id === bundle.id);
    if (found) {
      updateBundleData(dataToStore);
    }
  }

  async function updateBundleData(data) {
    //setLoadUpdate(true);
    setModalLoader(true);
    return allService
      .update(data.id, data, `admin/bundles`, 'update', token)
      .then((serverData) => {
        setModalLoader(false);
        //setLoadUpdate(false);
        updateStateCopy(serverData.data.bundle, bundles, setBundle, false);
        updateStateCopy(
          serverData.data.bundle,
          bundleCopy,
          setBundleCopy,
          false,
        );
        toast.success(
          t('Bundle_updated'),
          {
            style: {
              padding: '16px',
              color: '#fff',
              borderRadius: '10px',
              background: '#02274a',
            },
            iconTheme: {
              primary: '#229954',
              secondary: '#FFFAEE',
            },
          },
          {
            duration: 10000,
          },
        );
      })
      .catch((e) => {
        setModalLoader(false);
        //setLoadUpdate(false);
        var found = bundles.find((element) => element.id === data.id);
        updateStateCopy(found, bundles, setBundle, false);
        updateStateCopy(found, bundleCopy, setBundleCopy, false);
        toast.error(
          t('A_server_error'),
          {
            style: {
              padding: '16px',
              color: '#fff',
              borderRadius: '10px',
              background: '#02274a',
            },
            iconTheme: {
              primary: '#FF0033',
              secondary: '#FFFAEE',
            },
          },
          {
            duration: 10000,
          },
        );
      });
  }

  const handleChangeBundleOperator = (operator) => {
    setNewBundle({
      ...newBundle,
      operator: operator.name,
      operator_id: operator.id,
      operator_code: operator.code,
    });
  };

  const handleChangeBundleData = (e) => {
    if (e.target.name === 'name') {
      setNewBundle({
        ...newBundle,
        name: e.target.value,
        code: e.target.value,
      });
    } else {
      setNewBundle({ ...newBundle, [e.target.name]: e.target.value });
    }
  };

  const handleChangeBundleOperatorToUpdate = (operator) => {
    setbundleToUpdate({
      ...bundleToUpdate,
      operator: operator.name,
      operator_id: operator.id,
      operator_code: operator.code,
    });
  };
  const handleChangeBundleToUpdate = (e) => {
    if (e.target.name === 'name') {
      setbundleToUpdate({
        ...bundleToUpdate,
        name: e.target.value,
        code: e.target.value,
      });
    } else {
      setbundleToUpdate({ ...bundleToUpdate, [e.target.name]: e.target.value });
    }
  };

  const submitNewBundle = (e) => {
    e.preventDefault();
    setLoad(true);
    setError('');
    return allService
      .create(newBundle, `admin/bundles/create`, token)
      .then((serverData) => {
        setLoad(false);
        setNewBundle({
          operator: operators[0].name,
          operator_id: operators[0].id,
          operator_code: operators[0].code,
          code: '',
          name: '',
          price: '',
          description: '',
        });
        var all_bundles = [...bundles];
        all_bundles.unshift(serverData.data.bundle);
        setBundle(all_bundles);
        setBundleCopy(all_bundles);
        displayAddBundleForm(false);
        toast.success(
          t('New_bundle_added'),
          {
            style: {
              padding: '16px',
              color: '#fff',
              borderRadius: '10px',
              background: '#02274a',
            },
            iconTheme: {
              primary: '#229954',
              secondary: '#FFFAEE',
            },
          },
          {
            duration: 10000,
          },
        );
      })
      .catch((e) => {
        setLoad(false);
        setError(t('A_server_error'));
      });
  };

  const updateBundle = (bundle) => {
    displayUpdateBundleForm(true);
    setbundleToUpdate(bundle);
  };

  const updateTransac = (transac) => {
    displayUpdateTransacForm(true);
    setTransacToUpdate(transac);
  };

  async function validateTransac(uuid) {
    setModalLoader(true);
    return allService
      .updateTransac(uuid, `admin/transactions/${uuid}/validate`, token)
      .then((serverData) => {
        setModalLoader(false);
        updateStateCopy(
          serverData.transaction,
          dataTransaction,
          setDataTransaction,
          true,
        );
        setTransacToUpdate(serverData.transaction);
        //displayUpdateTransacForm(false);
        toast.success(
          t('Transaction_validated'),
          {
            style: {
              padding: '16px',
              color: '#fff',
              borderRadius: '10px',
              background: '#02274a',
            },
            iconTheme: {
              primary: '#229954',
              secondary: '#FFFAEE',
            },
          },
          {
            duration: 10000,
          },
        );
      })
      .catch((e) => {
        setModalLoader(false);
        toast.error(
          t('A_server_error'),
          {
            style: {
              padding: '16px',
              color: '#fff',
              borderRadius: '10px',
              background: '#02274a',
            },
            iconTheme: {
              primary: '#FF0033',
              secondary: '#FFFAEE',
            },
          },
          {
            duration: 10000,
          },
        );
      });
  }

  function getDataAnalysis() {
    allService
      .getAll('admin/statistique/list', token)
      .then((d) => {
        setDataAnalysis(d.monthsTransactions);
      })
      .catch((e) => {});
  }

  useEffect(() => {
    getDataAnalysis();
  }, []);

  return (
    <React.Fragment>
      <div
        className="w-100"
        style={{ height: 'auto', position: 'fixed', zIndex: 2000 }}
      >
        <div
          className="text-center elipsis pl-2 pr-2"
          style={{ background: '#C69E44', color: '#fff' }}
        >
          <span className="ads-txt">
            <span>
              <strong>No 1</strong>
            </span>{' '}
            {t('Number_refill')}
            <span className="font-weight-light">&nbsp;</span>
          </span>
        </div>
        <div
          style={{
            height: '70px',
            background: '#000a2b',
            color: '#fff',
            padding: '0 20px',
          }}
        >
          <div className="fl-l logo" style={{ position: 'relative' }}>
            <img className="img-fluid" src="assets/img/glo-pay.png" alt="" />
          </div>
          <div
            className="fl-r cursor"
            style={{
              display: 'inline-block',
              verticalAlign: 'bottom',
              fontSize: '0.795em',
              position: 'relative',
              top: '16px',
            }}
          >
            <a
              data-toggle="dropdown"
              className="btn btn-primary option rounded-circle"
              role="button"
              href="#"
              style={{
                display: 'inline-block',
                padding: '1px 5px',
                paddingTop: '5px',
                fontSize: '0.985em',
                boxShadow: 'none',
                position: 'relative',
              }}
            >
              <i className="material-icons">person</i>
            </a>
            <div
              className="d-none d-md-inline-block text-left"
              style={{
                marginLeft: '6px',
                paddingRight: '10px',
                verticalAlign: 'top',
                position: 'relative',
                top: '-2px',
              }}
              data-toggle="dropdown"
            >
              <h6
                className="fw-400 mb-0 d-inline-block mr-2"
                style={{ fontSize: '0.965em' }}
              >
                {user.name.split(' ')[0]}
                <strong>{user.name.split(' ')[1]}</strong>
              </h6>
              <i
                className="icon-arrow-down cursor"
                style={{ fontSize: '0.835em', position: 'relative' }}
              ></i>
              <span
                className="d-block pr"
                style={{ fontSize: '0.765em', top: '-7px' }}
              >
                {allService.chunk(user.telephone, 3, ' ')}
              </span>
            </div>
            <div
              className="dropdown-menu drop-lang"
              role="menu"
              style={{
                minWidth: '180px',
                fontSize: '1.26em',
                marginTop: '5px',
                marginRight: '18px',
              }}
            >
              <h6
                className="fw-400 pr mb-0 d-md-none"
                style={{ left: '15px', fontSize: '0.965em' }}
              >
                {user.name.split(' ')[0]}
                <strong>{user.name.split(' ')[1]}</strong>
              </h6>
              <span
                className="d-block pr d-md-none"
                style={{ fontSize: '0.665em', top: '-4px', left: '15px' }}
              >
                {allService.chunk(user.telephone, 3, ' ')}
              </span>
              {isAuthenticated && (
                <a onClick={() => disconnect()}>
                  <i
                    className="material-icons pr menu-i mr-1"
                    style={{ top: '3.9px', fontSize: '1.4em', padding: '1px' }}
                  >
                    power_settings_new
                  </i>
                  &nbsp;<span className="lang">{t('disconnect')}</span>
                </a>
              )}
            </div>
          </div>
          <div
            className="fl-r mr-2"
            style={{
              display: 'inline-block',
              verticalAlign: 'bottom',
              fontSize: '0.795em',
              position: 'relative',
              top: '16px',
            }}
          >
            <div
              style={{
                marginRight: '5px',
                display: 'inline-block',
                verticalAlign: 'middle',
              }}
            >
              <span className="lang">{lang}</span>
            </div>
            <button
              className="btn btn-primary option rounded-circle"
              type="button"
              style={{
                display: 'inline-block',
                padding: '1px 5px',
                paddingTop: '5px',
                fontSize: '0.985em',
                boxShadow: 'none',
                position: 'relative',
              }}
              data-toggle="dropdown"
              title="Langue"
            >
              <i className="material-icons">language</i>
            </button>
            <div
              className="dropdown-menu drop-lang"
              role="menu"
              style={{
                marginRight: '16px',
                marginTop: '5px',
                fontSize: '1.26em',
              }}
            >
              <a
                onClick={() => changeLanguageHandler('Fr')}
                id="fr"
                className="translate"
                data-reload
              >
                <img
                  src="assets/img/france_96px.png"
                  style={{ width: '20px', position: 'relative', top: '-3px' }}
                />
                &nbsp;{' '}
                <span
                  className="lang"
                  style={{ position: 'relative', top: '-2px' }}
                >
                  {t('french-lang')}
                </span>
                <br />
              </a>
              <a
                onClick={() => changeLanguageHandler('En')}
                id="en"
                className="translate"
              >
                <img
                  src="assets/img/great_britain_96px-1.png"
                  style={{ width: '20px', position: 'relative', top: '-3px' }}
                />
                &nbsp;{' '}
                <span
                  className="lang"
                  style={{ position: 'relative', top: '-2px' }}
                >
                  {t('english-lang')}
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div style={{ height: '95px' }} />
      <div className="row col-12 m-auto p-0" style={{ zIndex: 1 }}>
        <div className="col col-12 p-0">
          <div
            className="content text-left col-12"
            style={{
              position: 'relative',
              background: 'inherit',
              zIndex: 2000,
            }}
          >
            <div className="container">
              <div style={{ display: 'block' }}>
                <h3 className="fw-900 mb-0">
                  {' '}
                  {allService.numberWithCommas(
                    count1.length > 0
                      ? count1.reduce((accumulator, object) => {
                          return accumulator + object.amount;
                        }, 0)
                      : 0,
                  )}{' '}
                  Fcfa
                </h3>
                <span className="d-block mb-3">
                  {count} transaction(s) total
                </span>
                <div className="col p-0 col-12" style={{ height: '100%' }}>
                  <div
                    className="table-content pt-0"
                    style={{ height: '100%' }}
                  >
                    <div style={{ height: '110px' }}>
                      <form
                        className="search col-12 col-md-6 p-0"
                        style={{
                          display: 'block',
                          background: '#fff',
                          verticalAlign: 'top',
                          height: '45px',
                          handlewidth: '100%',
                        }}
                      >
                        <div
                          style={{
                            display: 'inline-block',
                            width: '100%',
                            boxShadow: '0 10px 20px -8px rgba(0, 0, 0, 0.24)',
                          }}
                        >
                          <div
                            style={{
                              display: 'inline-block',
                              textAlign: 'center',
                              width: '50px',
                              position: 'relative',
                              height: '45px',
                              padding: '7px',
                              paddingTop: '10px',
                            }}
                          >
                            <i
                              className="icon-magnifier"
                              style={{ fontSize: '1.6em' }}
                            />
                          </div>
                          <input
                            className="form-control"
                            type="text"
                            onChange={(e) => handleFilter(e)}
                            placeholder={t('search_a_transaction')}
                            style={{
                              background: 'inherit',
                              color: 'inherit',
                              borderRadius: 0,
                              height: '45px',
                              display: 'inline-block',
                              width: '43%',
                              border: 'NONE',
                              verticalAlign: 'top',
                              boxShadow: 'none',
                              fontSize: '13px',
                            }}
                            name="clear"
                            value={clear}
                          />
                          <div
                            style={{
                              float: 'right',
                              display: 'inline-block',
                              position: 'relative',
                              right: '7px',
                              width: '40%',
                            }}
                          >
                            <div
                              className="d-inline-block mt-1 select-items"
                              style={{ width: '100%', height: '38px' }}
                            >
                              <button
                                className="btn btn-primary option btn-select open-list bg-i h-100"
                                type="button"
                              >
                                &nbsp;{' '}
                                <span className="lang mr-2 fl-l fw-600">
                                  {t('Show_all')}
                                </span>
                                <i className="icon-arrow-down fl-r fw-600" />
                              </button>
                              <div
                                className="drop-lang option-list mt-2"
                                style={{ width: '100%' }}
                              >
                                <h6
                                  className="elipsis"
                                  style={{ fontSize: '0.9em' }}
                                  title="Filtrer par catégorie"
                                >
                                  {t('Filter_by_status')}
                                </h6>
                                {TransactionStatus.slice(
                                  0,
                                  TransactionStatus.length - 1,
                                ).map((status, index) => {
                                  return (
                                    <a
                                      key={index}
                                      className="choice choice1 mb-1 elipsis"
                                      onClick={() => handleStatus(status.value)}
                                      data-id={index}
                                      data-name={status.label}
                                    >
                                      {status.label}
                                    </a>
                                  );
                                })}
                                <a
                                  onClick={() => handleStatus('all')}
                                  className="choice choice-selected mb-1 elipsis"
                                  data-id={
                                    TransactionStatus[
                                      TransactionStatus.length - 1
                                    ].value
                                  }
                                  data-name={
                                    TransactionStatus[
                                      TransactionStatus.length - 1
                                    ].label
                                  }
                                >
                                  {
                                    TransactionStatus[
                                      TransactionStatus.length - 1
                                    ].label
                                  }
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                      <div
                        className="mt-3"
                        style={{ width: '100%', height: '50px' }}
                      >
                        <button
                          disabled={tableLoader}
                          onClick={() => showSetting(!setting)}
                          className="btn btn-primary app-btn mr-3"
                          type="button"
                          style={{
                            textTransform: 'none',
                            position: 'relative',
                          }}
                        >
                          <i className="icon-settings mr-1"></i>
                          <span>{t('Settings')}</span>
                        </button>
                        <button
                          disabled={tableLoader}
                          onClick={() => getData(true)}
                          className="btn btn-primary btn-opt"
                          type="button"
                          style={{
                            display: 'inline-block',
                            marginRight: '15px',
                            boxShadow: 'none',
                          }}
                        >
                          <i className="icon-refresh mr-1" />
                          &nbsp;
                          <span className="lang">{t('Refresh_list')}</span>
                          <br />
                        </button>
                      </div>
                    </div>
                    {!tableLoader && (
                      <div
                        className="mb-2"
                        style={{
                          height: '60px',
                          background: '#fff',
                          padding: '10px 10px',
                        }}
                      >
                        <div
                          className="col col-5 col-lg-3"
                          style={{ float: 'left', padding: 0 }}
                        >
                          <div className="input">
                            <div
                              className="d-inline-block mt-1 select-items"
                              style={{ width: '100%', height: '38px' }}
                            >
                              <button
                                className="btn btn-primary option btn-select open-list option-list2 bg-i"
                                type="button"
                                style={{
                                  height: '100%',
                                  background: 'inherit!important',
                                }}
                              >
                                &nbsp;
                                <span className="lang mr-2 fl-l fw-600">
                                  {TransactionCount[0].label}
                                </span>
                                <i className="icon-arrow-down fl-r fw-600" />
                              </button>
                              <div
                                className="drop-lang option-list mt-2"
                                style={{ width: '100%' }}
                              >
                                <a
                                  className="choice mb-1 elipsis choice-selected"
                                  onClick={() => handleNumberFilter(10)}
                                  data-id={TransactionCount[0].value}
                                  data-name={TransactionCount[0].label}
                                >
                                  {TransactionCount[0].label}
                                </a>
                                {TransactionCount.slice(1).map(
                                  (collection, index) => {
                                    return (
                                      <a
                                        key={index}
                                        className="choice mb-1 elipsis"
                                        onClick={() =>
                                          handleNumberFilter(collection.value)
                                        }
                                        data-id={index}
                                        data-name={collection.label}
                                      >
                                        {collection.label}
                                      </a>
                                    );
                                  },
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="col col-6 d-none d-sm-block"
                          style={{
                            float: 'right',
                            position: 'relative',
                            top: '13px',
                          }}
                        >
                          <span
                            className="row_count_warehouse"
                            style={{ float: 'right' }}
                          >
                            {t('From')} {paginatedData.length > 0 ? 1 : 0}{' '}
                            {t('to')} {paginatedData.length} {t('out_of')}{' '}
                            {count}
                          </span>
                        </div>
                      </div>
                    )}
                    {!tableLoader && (
                      <div
                        style={{
                          background: '#fff',
                          minHeight: '400px',
                          padding: '15px 10px',
                        }}
                      >
                        <div
                          style={{
                            minHeight: '380px',
                            maxHeight: '500px',
                            overflow: 'auto',
                          }}
                        >
                          <table className="table">
                            <thead>
                              <tr
                                style={{
                                  borderTop: 'hidden',
                                  borderBottom: 'hidden',
                                }}
                              >
                                <th className="lang" width="150px">
                                  #
                                </th>
                                <th className="lang" width="150px">
                                  {t('Transaction_type')}
                                </th>
                                <th className="lang" width="150px">
                                  {t('Assigned_for')}
                                </th>
                                <th className="lang" width="95px">
                                  {t('Status')}
                                </th>
                                <th className="lang" width="150px">
                                  {t('Paid')}
                                </th>
                                <th className="lang" width="150px">
                                  {t('Validated_by')}
                                </th>
                                <th className="lang text-left" width="130px">
                                  {t('Number_to_be_credited')}
                                </th>
                                <th className="lang" width="140px">
                                  {t('Payer_number')}
                                </th>
                                <th className="lang" width="110px">
                                  {t('Amount')}
                                </th>
                                <th className="lang" width="200px">
                                  {t('Bundle')}
                                </th>
                                <th className="lang" width="230px">
                                  {t('Transaction_date')}
                                </th>
                                <th className="lang" width="230px">
                                  Transaction validé le
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {paginatedData.map((d, index) => {
                                return (
                                  <tr
                                    onClick={() => updateTransac(d)}
                                    key={index}
                                    style={{ borderTop: 'hidden' }}
                                    className="read"
                                  >
                                    <td className="elipsis">
                                      {operators.find(
                                        (e) => e.name === d.receiver_network,
                                      ) && (
                                        <img
                                          src={
                                            operators.find(
                                              (e) =>
                                                e.name === d.receiver_network,
                                            ).image
                                          }
                                          className="d-inline-block va-t pr mr-2 paiement-logo pr"
                                          style={{ width: '20px', top: '0px' }}
                                          alt=""
                                        />
                                      )}
                                      {d.uuid}
                                    </td>
                                    <td className="elipsis">
                                      {d.type === 'TOPUP'
                                        ? t('Purchase_Credit')
                                        : t('Purchase_Bundle')}
                                    </td>
                                    <td className="elipsis">
                                      {d.assigned_to_name}
                                    </td>
                                    {d.status === 'NEW' && (
                                      <td>
                                        <div
                                          className="new fw-500"
                                          style={{
                                            fontSize: '0.824em',
                                            textAlign: 'center',
                                          }}
                                        >
                                          {t('New')}
                                        </div>
                                      </td>
                                    )}
                                    {d.status === 'PENDING' && (
                                      <td>
                                        <div
                                          className="in-progress fw-500"
                                          style={{
                                            fontSize: '0.824em',
                                            textAlign: 'center',
                                          }}
                                        >
                                          {t('In_progress')}
                                        </div>
                                      </td>
                                    )}
                                    {d.status === 'COMPLETED' && (
                                      <td>
                                        <div
                                          className="active fw-500"
                                          style={{
                                            fontSize: '0.824em',
                                            textAlign: 'center',
                                          }}
                                        >
                                          {t('Completed')}
                                        </div>
                                      </td>
                                    )}
                                    {d.status === 'FAILED' && (
                                      <td>
                                        <div
                                          className="canceled fw-500"
                                          style={{
                                            fontSize: '0.824em',
                                            textAlign: 'center',
                                          }}
                                        >
                                          {t('Failed')}
                                        </div>
                                      </td>
                                    )}
                                    {d.payment_successful === 0 && (
                                      <td>
                                        <div
                                          className=" fw-500"
                                          style={{ fontSize: '0.824em' }}
                                        >
                                          NO
                                        </div>
                                      </td>
                                    )}
                                    {d.payment_successful === 1 && (
                                      <td>
                                        <div
                                          className=" fw-500"
                                          style={{ fontSize: '0.824em' }}
                                        >
                                          YES
                                        </div>
                                      </td>
                                    )}
                                    <td className="elipsis">
                                      {d.validated_by_name}
                                    </td>
                                    <td className="elipsis">
                                      {allService.chunk(
                                        d.receiver_number,
                                        3,
                                        ' ',
                                      )}
                                    </td>
                                    <td className="elipsis">
                                      {d.payer_number
                                        ? allService.chunk(
                                            d.payer_number,
                                            3,
                                            ' ',
                                          )
                                        : ''}
                                    </td>
                                    <td className="elipsis">
                                      {allService.numberWithCommas(d.amount)}{' '}
                                      Fcfa
                                    </td>
                                    <td>
                                      {d.bundle_name
                                        ? d.bundle_name
                                        : t('Not_defined')}
                                    </td>
                                    <td>
                                      {d.created_at &&
                                        new Date(
                                          d.created_at,
                                        ).toLocaleDateString('fr-FR', {
                                          weekday: 'long',
                                          year: 'numeric',
                                          month: 'long',
                                          day: 'numeric',
                                          hour: 'numeric',
                                          minute: 'numeric',
                                        })}
                                    </td>
                                    <td>
                                      {d.validated_at &&
                                        new Date(
                                          d.validated_at,
                                        ).toLocaleDateString('fr-FR', {
                                          weekday: 'long',
                                          year: 'numeric',
                                          month: 'long',
                                          day: 'numeric',
                                          hour: 'numeric',
                                          minute: 'numeric',
                                        })}
                                    </td>
                                  </tr>
                                );
                              })}
                              {count === 0 && (
                                <tr
                                  className="warning no-result-warehous"
                                  style={{ borderTop: 'hidden' }}
                                >
                                  <td colSpan={2}>
                                    <i className="fa fa-warning" />
                                    &nbsp;&nbsp;
                                    <span className="lang" key="no-result">
                                      {t('No_result')}
                                    </span>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                        <div style={{ height: '40px', marginTop: '10px' }}>
                          <Pagination
                            currentPage={currentPage}
                            setCurrentPage={(e) => pagination(e)}
                            totalPages={pages}
                            edgePageCount={2}
                            middlePagesSiblingCount={2}
                            className="pagination"
                            truncableText="..."
                            truncableClassName=""
                          >
                            <Pagination.PrevButton className="page-link page-item">
                              «
                            </Pagination.PrevButton>

                            <Pagination.PageButton
                              activeClassName="bluepaginate"
                              inactiveClassName=""
                              className="page-link page-item"
                            />

                            <Pagination.NextButton className="page-link page-item">
                              »
                            </Pagination.NextButton>
                          </Pagination>
                        </div>
                        <div>
                          <HighchartsReact
                            highcharts={Highcharts}
                            options={options}
                          />
                          <input
                            type="date"
                            onChange={(event) => {
                              setenteredDate(event.target.value);
                            }}
                          />

                          <HighchartsReact
                            highcharts={Highcharts}
                            options={weekly}
                          />
                        </div>
                      </div>
                    )}
                    <TableLoader
                      display={tableLoader}
                      isUserTable={false}
                      height={'500'}
                    />
                  </div>
                </div>
                <span
                  className="fw-100 second-txt-color d-block mb-2 mt-4"
                  style={{
                    color: '#A6ACAF',
                    fontWeight: 100,
                    fontSize: '0.865em',
                  }}
                >
                  <i className="fa fa-copyright fw-100" />
                  &nbsp;<span>2022</span>&nbsp;
                  <strong>Glotelho Pay&nbsp;</strong>
                  <span className="lang fw-100 second-txt-color">
                    {t('All_rights_reserved')}
                  </span>
                  .
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="modal modal-setting" style={{ display: '' }}>
        <div
          id="modal-setting"
          className="modal-content"
          style={{ overflow: 'auto', width: '45%' }}
        >
          <div style={{ textAlign: 'right' }}>
            <i
              onClick={() => showSetting(!setting)}
              className="icon ion-android-close close"
              id="close-user-edit"
              style={{
                color: 'inherit',
                float: 'right',
                fontWeight: 'bold',
                cursor: 'pointer',
                position: 'relative',
                top: '0px',
                left: '20px',
              }}
            />
          </div>
          {!addBundleForm && !updateBundleForm && (
            <div className="display setting-first" style={{ display: 'block' }}>
              <div className="mb-3">
                <h4 className="fw-800 lang mb-0">{t('Settings')}</h4>
                <div style={{ height: '30px' }}>
                  <span
                    onClick={() => handleClickTab('BUNDLE')}
                    className={`btn-tab ${tab.bundles ? 'active' : ''} mr-3`}
                    data-target="#transfert-mobile-unit"
                    data-div=".transfert-tab"
                    data-tab=".transfert-btn-tab"
                  >
                    {t('Mobile_data')}
                  </span>
                  <span
                    onClick={() => handleClickTab('OPERATOR')}
                    className={`btn-tab ${tab.operators ? 'active' : ''} mr-3`}
                    data-target="#transfert-details"
                    data-div=".transfert-tab"
                    data-tab=".transfert-btn-tab"
                  >
                    {t('Operators')}
                  </span>
                </div>
              </div>
              {tab.operators && (
                <div style={{ minHeight: '300px' }}>
                  <table className="table table-location-products">
                    <thead>
                      <tr
                        style={{
                          borderTop: 'hidden',
                          borderBottom: 'hidden',
                          fontSize: '0.75em',
                          color: '#5D6D7E',
                        }}
                      >
                        <th className="lang fw-300">{t('Operators')}</th>
                        <th className="lang fw-300 text-right" width="90px">
                          {t('Active_for')} TOPUP
                        </th>
                        <th className="lang fw-300 text-right" width="90px">
                          {t('Active_for')} DATA
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {operatorsCopy.map((operator, i) => {
                        return (
                          <tr
                            key={i}
                            className="read"
                            style={{ borderTop: 'hidden' }}
                          >
                            <td className="pt-0 pb-0">
                              <div>
                                <div
                                  className="d-inline-block mr-2"
                                  style={{ width: '20px' }}
                                >
                                  <img
                                    src={operator.image}
                                    className="img-fluid"
                                    alt=""
                                  />
                                </div>
                                <div
                                  className="d-inline-block"
                                  style={{
                                    width: 'Calc(100% - 45px)',
                                    verticalAlign: 'middle',
                                  }}
                                >
                                  <input
                                    onChange={(e) =>
                                      handleUpdateOperatorTitle(e, operator)
                                    }
                                    onBlur={(e) =>
                                      handleUpdatedOperatorTitle(e, operator)
                                    }
                                    type="text"
                                    value={
                                      operatorsCopy.find(
                                        (el) => el.id === operator.id,
                                      ).name
                                    }
                                    className="form-control editable-title d-inline-block cursor"
                                    style={{
                                      height: 'auto',
                                      fontSize: '1em',
                                      left: '-11px',
                                      fontWeight: 500,
                                      width: 'Calc(100% - 30px)',
                                    }}
                                  />
                                </div>
                              </div>
                            </td>
                            <td
                              className="text-right pt-0 pb-0"
                              style={{ fontSize: '0.865em' }}
                            >
                              <a style={{}}>
                                <label
                                  className="switch mb-0 fl-r"
                                  style={{ top: '6px' }}
                                  title="Activer/Désactiver"
                                >
                                  <input
                                    onChange={(e) =>
                                      handleUpdatedOperatorActivation(
                                        operator,
                                        e,
                                      )
                                    }
                                    name="TOPUP"
                                    type="checkbox"
                                    checked={
                                      operatorsCopy.find(
                                        (el) => el.id === operator.id,
                                      ).can_topup === 1
                                        ? true
                                        : false
                                    }
                                  />
                                  <span className="slider round" />
                                </label>
                              </a>
                            </td>
                            <td
                              className="text-right pt-0 pb-0"
                              style={{ fontSize: '0.865em' }}
                            >
                              <a style={{}}>
                                <label
                                  className="switch mb-0 fl-r"
                                  style={{ top: '6px' }}
                                  title="Activer/Désactiver"
                                >
                                  <input
                                    onChange={(e) =>
                                      handleUpdatedOperatorActivation(
                                        operator,
                                        e,
                                      )
                                    }
                                    name="BUNDLE"
                                    type="checkbox"
                                    checked={
                                      operatorsCopy.find(
                                        (el) => el.id === operator.id,
                                      ).can_activate_bundles === 1
                                        ? true
                                        : false
                                    }
                                  />
                                  <span className="slider round" />
                                </label>
                              </a>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
              {tab.bundles && (
                <div>
                  <form
                    className="col-12 col-md-11 col-xl-8 mb-2 p-0"
                    style={{
                      display: 'block',
                      background: '#fff',
                      verticalAlign: 'top',
                      height: '45px',
                    }}
                  >
                    <div
                      style={{
                        display: 'inline-block',
                        width: '100%',
                        boxShadow: '0 10px 20px -8px rgba(0, 0, 0, 0.24)',
                      }}
                    >
                      <div
                        className="d-none d-md-inline-block"
                        style={{
                          display: 'inline-block',
                          textAlign: 'center',
                          width: '50px',
                          position: 'relative',
                          height: '45px',
                          padding: '7px',
                          paddingTop: '10px',
                        }}
                      >
                        <i
                          className="icon-magnifier"
                          style={{ fontSize: '1.6em' }}
                        />
                      </div>
                      <input
                        name="clear1"
                        value={clear1}
                        type="text"
                        onChange={(e) => handleFilter1(e)}
                        placeholder={t('Bundle_filter')}
                        autoFocus
                        className="form-control research-user"
                        style={{
                          background: 'inherit',
                          color: 'inherit',
                          borderRadius: 0,
                          height: '45px',
                          display: 'inline-block',
                          width: '43%',
                          border: 'NONE',
                          verticalAlign: 'top',
                          boxShadow: 'none',
                          fontSize: '0.9em',
                        }}
                      />
                      <div
                        className="input app-color"
                        style={{
                          float: 'right',
                          display: 'inline-block',
                          position: 'relative',
                          /*top: '5px', */ right: '7px',
                          width: '40%',
                        }}
                      >
                        <div
                          className="d-inline-block mt-1 select-items"
                          style={{ width: '100%', height: '38px' }}
                        >
                          <button
                            className="btn btn-primary option btn-select open-list bg-i"
                            type="button"
                            style={{
                              height: '100%',
                              background: 'inherit!important',
                            }}
                          >
                            <span className="lang mr-2 fl-l fw-600">
                              {t('Show_all')}
                            </span>
                            <i className="icon-arrow-down fl-r fw-600" />
                          </button>
                          <div
                            className="drop-lang option-list mt-2"
                            style={{ width: '97%' }}
                          >
                            <h6 style={{ fontSize: '0.9em' }}>
                              {t('Filter_by_operator')}
                            </h6>
                            {operatorStatus
                              .slice(0, operatorStatus.length - 1)
                              .map((status, index) => {
                                return (
                                  <a
                                    key={index}
                                    className="choice choice1 mb-1 elipsis"
                                    onClick={() => handleStatus1(status.value)}
                                    data-id={index}
                                    data-name={status.label}
                                  >
                                    {status.label}
                                  </a>
                                );
                              })}
                            <a
                              onClick={() => handleStatus1('all')}
                              href="#"
                              className="choice choice-selected mb-1 elipsis"
                              data-id={2}
                              data-name="Tout affiché"
                            >
                              {t('Show_all')}
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                  <button
                    onClick={() => displayAddBundleForm(!addBundleForm)}
                    className="btn btn-primary app-btn mt-2 mb-3"
                    type="button"
                  >
                    <i className="icon ion-plus mr-1" />
                    <span className="lang">{t('New_bundle')}</span>
                  </button>
                  <div
                    style={{
                      background: '#fff',
                      padding: '15px 10px',
                      minHeight: '300px',
                      maxHeight: '450px',
                      overflow: 'auto',
                    }}
                  >
                    <table className="table table-location-products">
                      <thead>
                        <tr
                          style={{
                            borderTop: 'hidden',
                            borderBottom: 'hidden',
                            fontSize: '0.75em',
                            color: '#5D6D7E',
                          }}
                        >
                          <th className="lang fw-300">{t('Mobile_data')}</th>
                          <th className="lang fw-300 text-right" width="90px">
                            {t('Price')} (Fcfa)
                          </th>
                          <th className="lang fw-300 text-right" width="70px">
                            {t('Active')}
                          </th>
                        </tr>
                        {bundleCopy.length === 0 && (
                          <tr
                            className="warning no-result-warehous"
                            style={{ borderTop: 'hidden' }}
                          >
                            <td colSpan={3}>
                              <i className="fa fa-warning" />
                              <span className="lang"> {t('No_result')}</span>
                            </td>
                          </tr>
                        )}
                      </thead>
                      <tbody>
                        {bundleCopy.map((bundle, i) => {
                          return (
                            <tr
                              key={i}
                              onDoubleClick={() => updateBundle(bundle)}
                              className="read"
                              style={{ borderTop: 'hidden' }}
                            >
                              <td className="pt-0 pb-0">
                                <div>
                                  <div
                                    className="d-inline-block mr-2"
                                    style={{ width: '20px' }}
                                  >
                                    <img
                                      src={
                                        operators.find(
                                          (e) => e.name === bundle.operator,
                                        )
                                          ? operators.find(
                                              (e) => e.name === bundle.operator,
                                            ).image
                                          : ''
                                      }
                                      className="img-fluid"
                                    />
                                  </div>
                                  <div
                                    className="d-inline-block"
                                    style={{
                                      width: 'Calc(100% - 30px)',
                                      verticalAlign: 'middle',
                                    }}
                                  >
                                    <input
                                      onChange={(e) =>
                                        handleUpdateBundleData(e, bundle)
                                      }
                                      onBlur={(e) =>
                                        handleUpdatedBundleData(
                                          e,
                                          bundle,
                                          false,
                                        )
                                      }
                                      name="name"
                                      type="text"
                                      value={
                                        bundleCopy.find(
                                          (el) => el.id === bundle.id,
                                        ).name
                                      }
                                      className="form-control editable-title d-inline-block cursor elipsis"
                                      style={{
                                        height: 'auto',
                                        fontSize: '1em',
                                        left: '-11px',
                                        fontWeight: 500,
                                      }}
                                    />
                                  </div>
                                </div>
                              </td>
                              <td className="text-right p-0">
                                <input
                                  onChange={(e) =>
                                    handleUpdateBundleData(e, bundle)
                                  }
                                  onBlur={(e) =>
                                    handleUpdatedBundleData(e, bundle, false)
                                  }
                                  name="price"
                                  type="number"
                                  value={
                                    bundleCopy.find((el) => el.id === bundle.id)
                                      .price
                                  }
                                  className="form-control editable-title pr fl-r cursor p-0 text-right"
                                  style={{
                                    height: 'auto',
                                    fontSize: '1em',
                                    fontWeight: 500,
                                    right: '-8px',
                                    top: '10px',
                                  }}
                                />
                              </td>
                              <td
                                className="text-right pt-0 pb-0"
                                style={{ fontSize: '0.865em' }}
                              >
                                <a style={{}}>
                                  <label
                                    className="switch mb-0 fl-r"
                                    style={{ top: '7px' }}
                                    title="Activer/Désactiver"
                                  >
                                    <input
                                      onChange={(e) =>
                                        handleUpdatedBundleActivation(bundle, e)
                                      }
                                      type="checkbox"
                                      defaultChecked={
                                        bundle.active === 1 ? true : false
                                      }
                                    />
                                    <span className="slider round" />
                                  </label>
                                </a>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          )}
          {tab.operators && (
            <div className="display setting-third">
              <div className="mb-2">
                <h4 className="fw-800 lang mb-1 d-inline-block mr-1">
                  <i className="icon ion-arrow-left-c cursor" title="Retour" />
                </h4>
                <div className="d-inline-block va-t">
                  <h4 className="fw-800 lang mb-1 d-inline-block">
                    ORANGE NIGHT 1000
                  </h4>
                  <span
                    className="d-block pr fw-300"
                    style={{ top: '-5px', fontSize: '0.85em' }}
                  >
                    ORANGE | Dernière mise à jour le 30 Septembre 2022
                  </span>
                </div>
              </div>
              <div style={{ minHeight: '300px', display: 'none' }}>
                <table className="table table-location-products">
                  <thead>
                    <tr
                      style={{
                        borderTop: 'hidden',
                        borderBottom: 'hidden',
                        fontSize: '0.75em',
                        color: '#5D6D7E',
                      }}
                    >
                      <th className="lang fw-300">Opérateurs</th>
                      <th className="lang fw-300 text-right" width="90px">
                        Actif pour TOPUP
                      </th>
                      <th className="lang fw-300 text-right" width="90px">
                        Actif pour DATA
                      </th>
                    </tr>
                    <tr
                      className="warning no-result-warehouse"
                      style={{ borderTop: 'hidden' }}
                    >
                      <td colSpan={3}>
                        <i className="fa fa-warning" />
                        <span className="lang">Aucun résultat</span>
                      </td>
                    </tr>
                  </thead>
                  <tbody id="locationproductscontent">
                    <tr className="read" style={{ borderTop: 'hidden' }}>
                      <td className="pt-0 pb-0">
                        <div>
                          <div
                            className="d-inline-block mr-1"
                            style={{ width: '20px' }}
                          >
                            <img src="OM.jpg" className="img-fluid" alt="" />
                          </div>
                          <div
                            className="d-inline-block"
                            style={{
                              width: 'Calc(100% - 45px)',
                              verticalAlign: 'middle',
                            }}
                          >
                            <input
                              type="text"
                              defaultValue="ORANGE"
                              className="form-control editable-title d-inline-block cursor"
                              style={{
                                height: 'auto',
                                fontSize: '1em',
                                left: '-11px',
                                fontWeight: 500,
                                width: 'Calc(100% - 30px)',
                              }}
                            />
                          </div>
                        </div>
                      </td>
                      <td
                        className="text-right pt-0 pb-0"
                        style={{ fontSize: '0.865em' }}
                      >
                        <a style={{}}>
                          <label
                            className="switch mb-0"
                            style={{ float: 'right', top: '3px' }}
                            title="Activer/Désactiver"
                          >
                            <input type="checkbox" defaultChecked />
                            <span className="slider round" />
                          </label>
                        </a>
                      </td>
                      <td
                        className="text-right pt-0 pb-0"
                        style={{ fontSize: '0.865em' }}
                      >
                        <a style={{}}>
                          <label
                            className="switch mb-0"
                            style={{ float: 'right', top: '3px' }}
                            title="Activer/Désactiver"
                          >
                            <input type="checkbox" defaultChecked />
                            <span className="slider round" />
                          </label>
                        </a>
                      </td>
                    </tr>
                    <tr className="read" style={{ borderTop: 'hidden' }}>
                      <td className="pt-0 pb-0">
                        <div>
                          <div
                            className="d-inline-block mr-1"
                            style={{ width: '20px' }}
                          >
                            <img src="MOMO.jpg" className="img-fluid" />
                          </div>
                          <div
                            className="d-inline-block"
                            style={{
                              width: 'Calc(100% - 45px)',
                              verticalAlign: 'middle',
                            }}
                          >
                            <input
                              type="text"
                              defaultValue="MTN"
                              className="form-control editable-title d-inline-block cursor"
                              style={{
                                height: 'auto',
                                fontSize: '1em',
                                left: '-11px',
                                fontWeight: 500,
                                width: 'Calc(100% - 30px)',
                              }}
                            />
                          </div>
                        </div>
                      </td>
                      <td
                        className="text-right pt-0 pb-0"
                        style={{ fontSize: '0.865em' }}
                      >
                        <a style={{}}>
                          <label
                            className="switch mb-0"
                            style={{ float: 'right', top: '3px' }}
                            title="Activer/Désactiver"
                          >
                            <input type="checkbox" defaultChecked />
                            <span className="slider round" />
                          </label>
                        </a>
                      </td>
                      <td
                        className="text-right pt-0 pb-0"
                        style={{ fontSize: '0.865em' }}
                      >
                        <a style={{}}>
                          <label
                            className="switch mb-0"
                            style={{ float: 'right', top: '3px' }}
                            title="Activer/Désactiver"
                          >
                            <input type="checkbox" defaultChecked />
                            <span className="slider round" />
                          </label>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          )}
          {addBundleForm && (
            <div
              className="display setting-second"
              style={{ display: `${addBundleForm ? 'block' : 'none'}` }}
            >
              <div className="mb-2">
                <h4 className="fw-800 lang mb-1 d-inline-block mr-2">
                  <i
                    onClick={() => displayAddBundleForm(!addBundleForm)}
                    className="icon ion-arrow-left-c cursor"
                    title="Retour"
                  />
                </h4>
                <div className="d-inline-block va-t">
                  <h4 className="fw-800 lang mb-1 d-inline-block">
                    {t('New_bundle')}
                  </h4>
                  <span
                    className="d-block pr fw-300"
                    style={{ top: '-5px', fontSize: '0.85em' }}
                  >
                    {t('Once_created_enable')}
                  </span>
                </div>
              </div>
              <div style={{ minHeight: '300px', display: 'none' }}>
                <table className="table table-location-products">
                  <thead>
                    <tr
                      style={{
                        borderTop: 'hidden',
                        borderBottom: 'hidden',
                        fontSize: '0.75em',
                        color: '#5D6D7E',
                      }}
                    >
                      <th className="lang fw-300" width>
                        Opérateurs
                      </th>
                      <th className="lang fw-300 text-right" width="90px">
                        Actif pour TOPUP
                      </th>
                      <th className="lang fw-300 text-right" width="90px">
                        Actif pour DATA
                      </th>
                    </tr>
                    <tr
                      className="warning no-result-warehouse"
                      style={{ borderTop: 'hidden' }}
                    >
                      <td colSpan={3}>
                        <i className="fa fa-warning" />
                        <span className="lang">Aucun résultat</span>
                      </td>
                    </tr>
                  </thead>
                  <tbody id="locationproductscontent">
                    <tr className="read" style={{ borderTop: 'hidden' }}>
                      <td className="pt-0 pb-0">
                        <div>
                          <div
                            className="d-inline-block mr-1"
                            style={{ width: '20px' }}
                          >
                            <img src="OM.jpg" className="img-fluid" />
                          </div>
                          <div
                            className="d-inline-block"
                            style={{
                              width: 'Calc(100% - 45px)',
                              verticalAlign: 'middle',
                            }}
                          >
                            <input
                              type="text"
                              defaultValue="ORANGE"
                              className="form-control editable-title d-inline-block cursor"
                              style={{
                                height: 'auto',
                                fontSize: '1em',
                                left: '-11px',
                                fontWeight: 500,
                                width: 'Calc(100% - 30px)',
                              }}
                            />
                          </div>
                        </div>
                      </td>
                      <td
                        className="text-right pt-0 pb-0"
                        style={{ fontSize: '0.865em' }}
                      >
                        <a style={{}}>
                          <label
                            className="switch mb-0"
                            style={{ float: 'right', top: '3px' }}
                            title="Activer/Désactiver"
                          >
                            <input type="checkbox" defaultChecked />
                            <span className="slider round" />
                          </label>
                        </a>
                      </td>
                      <td
                        className="text-right pt-0 pb-0"
                        style={{ fontSize: '0.865em' }}
                      >
                        <a style={{}}>
                          <label
                            className="switch mb-0"
                            style={{ float: 'right', top: '3px' }}
                            title="Activer/Désactiver"
                          >
                            <input type="checkbox" defaultChecked />
                            <span className="slider round" />
                          </label>
                        </a>
                      </td>
                    </tr>
                    <tr className="read" style={{ borderTop: 'hidden' }}>
                      <td className="pt-0 pb-0">
                        <div>
                          <div
                            className="d-inline-block mr-1"
                            style={{ width: '20px' }}
                          >
                            <img src="MOMO.jpg" className="img-fluid" alt="" />
                          </div>
                          <div
                            className="d-inline-block"
                            style={{
                              width: 'Calc(100% - 45px)',
                              verticalAlign: 'middle',
                            }}
                          >
                            <input
                              type="text"
                              defaultValue="MTN"
                              className="form-control editable-title d-inline-block cursor"
                              style={{
                                height: 'auto',
                                fontSize: '1em',
                                left: '-11px',
                                fontWeight: 500,
                                width: 'Calc(100% - 30px)',
                              }}
                            />
                          </div>
                        </div>
                      </td>
                      <td
                        className="text-right pt-0 pb-0"
                        style={{ fontSize: '0.865em' }}
                      >
                        <a style={{}}>
                          <label
                            className="switch mb-0"
                            style={{ float: 'right', top: '3px' }}
                            title="Activer/Désactiver"
                          >
                            <input type="checkbox" defaultChecked />
                            <span className="slider round" />
                          </label>
                        </a>
                      </td>
                      <td
                        className="text-right pt-0 pb-0"
                        style={{ fontSize: '0.865em' }}
                      >
                        <a style={{}}>
                          <label
                            className="switch mb-0"
                            style={{ float: 'right', top: '3px' }}
                            title="Activer/Désactiver"
                          >
                            <input type="checkbox" defaultChecked />
                            <span className="slider round" />
                          </label>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <form
                onSubmit={(e) => submitNewBundle(e)}
                className="col-12"
                style={{
                  display: 'block',
                  verticalAlign: 'top',
                  width: '100%',
                  padding: 0,
                }}
              >
                <div className="form-row">
                  <div className="col col-12 col-sm-4 mb-4">
                    <div>
                      <span
                        className="lang elipsis d-block"
                        style={{ fontWeight: 300, fontSize: '0.9rem' }}
                      >
                        {t('Operators')}
                      </span>
                      <div
                        className="d-inline-block mt-1 select-items"
                        style={{ width: '100%' }}
                      >
                        <button
                          className="btn btn-primary option btn-select open-list"
                          type="button"
                          style={{ backgroundColor: 'var(--input-background)' }}
                        >
                          <span className="lang mr-2 fl-l fw-600">
                            {newBundle.operator}
                          </span>
                          <i className="icon-arrow-down fl-r fw-600" />
                        </button>
                        <div
                          className="drop-lang option-list mt-2"
                          style={{ width: '97%' }}
                        >
                          {operators.map((operator, id) => {
                            return (
                              <a
                                href="#"
                                key={id}
                                onClick={() =>
                                  handleChangeBundleOperator(operator)
                                }
                                className={`choice mb-1 elipsis ${
                                  newBundle.operator_id === operator.id
                                    ? 'choice-selected'
                                    : ''
                                }`}
                                data-name={operator.name}
                              >
                                {operator.name}
                              </a>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col col-12 col-sm-4 mb-4">
                    <div>
                      <span
                        className="lang elipsis d-block"
                        style={{ fontWeight: 300, fontSize: '0.9rem' }}
                      >
                        {t('name')}
                      </span>
                      <input
                        onChange={(e) => handleChangeBundleData(e)}
                        name="name"
                        value={newBundle.name}
                        type="text"
                        className="form-control mt-1"
                      />
                    </div>
                  </div>
                  <div className="col col-12 col-sm-4 mb-4">
                    <div>
                      <span
                        className="lang elipsis d-block"
                        style={{ fontWeight: 300, fontSize: '0.9rem' }}
                      >
                        {t('Price')} (Fcfa)
                      </span>
                      <input
                        onChange={(e) => handleChangeBundleData(e)}
                        name="price"
                        value={newBundle.price}
                        type="number"
                        className="form-control mt-1"
                      />
                    </div>
                  </div>
                </div>
                <div className="form-row mb-4">
                  <div className="col col-12">
                    <div>
                      <span
                        className="lang elipsis d-block"
                        style={{ fontWeight: 300, fontSize: '0.9rem' }}
                      >
                        Description
                      </span>
                      <textarea
                        onChange={(e) => handleChangeBundleData(e)}
                        name="description"
                        value={newBundle.description}
                        className="form-control mt-1"
                        style={{ height: '150px' }}
                      />
                    </div>
                  </div>
                </div>
                <div className="mt-2" style={{ height: '63px' }}>
                  <button
                    disabled={
                      load ||
                      allService.empty(newBundle.name) ||
                      allService.empty(newBundle.price) ||
                      allService.empty(newBundle.description)
                    }
                    className="btn btn-primary app-btn mt-1 mb-2"
                    type="submit"
                    style={{ padding: '15px', float: 'right' }}
                  >
                    {!load && <i className="icon-screen-tablet mr-2 pr" />}
                    {load && (
                      <i className="fa fa-circle-o-notch fa-spin speed-spin mr-2"></i>
                    )}
                    <span className="lang">{t('ADD_BUNDLE')}</span>
                  </button>
                </div>
                {!allService.empty(error) && (
                  <span className="err fl-r">{error}</span>
                )}
              </form>
            </div>
          )}

          {updateBundleForm && (
            <div
              className="display setting-second"
              style={{ display: `${updateBundleForm ? 'block' : 'none'}` }}
            >
              <div className="mb-2">
                <h4 className="fw-800 lang mb-1 d-inline-block mr-2">
                  <i
                    onClick={() => displayUpdateBundleForm(false)}
                    className="icon ion-arrow-left-c cursor"
                    title="Retour"
                  />
                </h4>
                <div className="d-inline-block va-t">
                  <h4 className="fw-800 lang mb-1 d-inline-block">
                    {bundleToUpdate.name}
                  </h4>
                  <span
                    className="d-block pr fw-300"
                    style={{ top: '-5px', fontSize: '0.85em' }}
                  >
                    Mis à jour depuis{' '}
                    {bundleToUpdate.updated_at &&
                      new Date(bundleToUpdate.updated_at).toLocaleDateString(
                        'fr-FR',
                        {
                          weekday: 'long',
                          year: 'numeric',
                          month: 'long',
                          day: 'numeric',
                        },
                      )}
                    .
                  </span>
                </div>
              </div>
              <form
                onSubmit={(e) =>
                  handleUpdatedBundleData(e, bundleToUpdate, true)
                }
                className="col-12"
                style={{
                  display: 'block',
                  verticalAlign: 'top',
                  width: '100%',
                  padding: 0,
                }}
              >
                <div className="form-row">
                  <div className="col col-12 col-sm-4 mb-4">
                    <div>
                      <span
                        className="lang elipsis d-block"
                        style={{ fontWeight: 300, fontSize: '0.9rem' }}
                      >
                        {t('Operator')}
                      </span>
                      <div
                        className="d-inline-block mt-1 select-items"
                        style={{ width: '100%' }}
                      >
                        <button
                          className="btn btn-primary option btn-select open-list"
                          type="button"
                          style={{ backgroundColor: 'var(--input-background)' }}
                        >
                          <span className="lang mr-2 fl-l fw-600">
                            {bundleToUpdate.operator}
                          </span>
                          <i className="icon-arrow-down fl-r fw-600" />
                        </button>
                        <div
                          className="drop-lang option-list mt-2"
                          style={{ width: '97%' }}
                        >
                          {operators.map((operator, id) => {
                            return (
                              <a
                                href="#"
                                key={id}
                                onClick={() =>
                                  handleChangeBundleOperatorToUpdate(operator)
                                }
                                className={`choice mb-1 elipsis ${
                                  bundleToUpdate.operator_id === operator.id
                                    ? 'choice-selected'
                                    : ''
                                }`}
                                data-name={operator.name}
                              >
                                {operator.name}
                              </a>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col col-12 col-sm-4 mb-4">
                    <div>
                      <span
                        className="lang elipsis d-block"
                        style={{ fontWeight: 300, fontSize: '0.9rem' }}
                      >
                        {t('name')}
                      </span>
                      <input
                        onChange={(e) => handleChangeBundleToUpdate(e)}
                        name="name"
                        value={bundleToUpdate.name}
                        type="text"
                        className="form-control mt-1"
                      />
                    </div>
                  </div>
                  <div className="col col-12 col-sm-4 mb-4">
                    <div>
                      <span
                        className="lang elipsis d-block"
                        style={{ fontWeight: 300, fontSize: '0.9rem' }}
                      >
                        {t('Price')} (Fcfa)
                      </span>
                      <input
                        onChange={(e) => handleChangeBundleToUpdate(e)}
                        name="price"
                        value={bundleToUpdate.price}
                        type="number"
                        className="form-control mt-1"
                      />
                    </div>
                  </div>
                </div>
                <div className="form-row mb-4">
                  <div className="col col-12">
                    <div>
                      <span
                        className="lang elipsis d-block"
                        style={{ fontWeight: 300, fontSize: '0.9rem' }}
                      >
                        Description
                      </span>
                      <textarea
                        onChange={(e) => handleChangeBundleToUpdate(e)}
                        name="description"
                        value={bundleToUpdate.description}
                        className="form-control mt-1"
                        style={{ height: '150px' }}
                      />
                    </div>
                  </div>
                </div>
                <div className="mt-2" style={{ height: '63px' }}>
                  <button
                    disabled={
                      loadUpdate ||
                      allService.empty(bundleToUpdate.name) ||
                      allService.empty(bundleToUpdate.price) ||
                      allService.empty(bundleToUpdate.description)
                    }
                    className="btn btn-primary app-btn mt-1 mb-2"
                    type="submit"
                    style={{ padding: '15px', float: 'right' }}
                  >
                    {!loadUpdate && (
                      <i
                        className="icon-cloud-upload mr-2 pr"
                        style={{ top: '1px' }}
                      />
                    )}
                    {loadUpdate && (
                      <i className="fa fa-circle-o-notch fa-spin speed-spin mr-2"></i>
                    )}
                    <span className="lang">{t('UPDATE')}</span>
                  </button>
                </div>
                {!allService.empty(error) && (
                  <span className="err fl-r">{error}</span>
                )}
              </form>
            </div>
          )}
        </div>
      </div>

      <div className="modal modal-transac" style={{ display: '' }}>
        <div
          id="modal-transac"
          className="modal-content"
          style={{ overflow: 'auto', width: '35%' }}
        >
          <div>
            <i
              className="icon ion-android-close close fl-r pr cursor: "
              onClick={() => displayUpdateTransacForm(!updateTransacForm)}
              style={{
                color: 'inherit',
                fontWeight: 'bold',
                top: '0px',
                left: '20px',
              }}
            ></i>
          </div>
          <div className="display text-left" style={{ display: 'block' }}>
            <div className="mb-3" style={{ border: 'none', padding: '0' }}>
              <img
                alt=""
                src={
                  operators.find(
                    (e) => e.name === transacToUpdate.receiver_network,
                  )
                    ? operators.find(
                        (e) => e.name === transacToUpdate.receiver_network,
                      ).image
                    : ''
                }
                className="d-inline-block va-t mr-2 paiement-logo pr"
                style={{ width: '46px' }}
              />
              <div
                className="d-inline-block"
                style={{ width: 'Calc(100% - 75px)' }}
              >
                <h4 className="fw-800 lang mb-0">
                  {transacToUpdate.type === 'TOPUP'
                    ? 'Achat de crédit'
                    : 'Achat de DATA'}
                </h4>
                {transacToUpdate.status === 'NEW' && (
                  <span
                    className="new fw-500 pr"
                    style={{
                      fontSize: '0.724em',
                      textAlign: 'center',
                      padding: '3px 5px',
                      top: '-2px',
                    }}
                  >
                    {t('New')}
                  </span>
                )}
                {transacToUpdate.status === 'PENDING' && (
                  <span
                    className="in-progress fw-500 pr"
                    style={{
                      fontSize: '0.724em',
                      textAlign: 'center',
                      padding: '3px 5px',
                      top: '-2px',
                    }}
                  >
                    {t('In_progress')}
                  </span>
                )}
                {transacToUpdate.status === 'COMPLETED' && (
                  <span
                    className="active fw-500 pr"
                    style={{
                      fontSize: '0.724em',
                      textAlign: 'center',
                      padding: '3px 5px',
                      top: '-2px',
                    }}
                  >
                    {t('Completed')}
                  </span>
                )}
                {transacToUpdate.status === 'FAILED' && (
                  <span
                    className="canceled fw-500 pr"
                    style={{
                      fontSize: '0.724em',
                      textAlign: 'center',
                      padding: '3px 5px',
                      top: '-2px',
                    }}
                  >
                    {t('Failed')}
                  </span>
                )}
                {/*<span className="d-inline-block mr-1" style={{background:`${transacToUpdate.status === 'COMPLETED'? '#1D8348' : '#D68910'}`, width:"10px", height:"10px"}}></span>
                        <span className='d-inline-block va-m' style={{width: "Calc(100% - 15px)"}}><span title={transacToUpdate.uuid} className="mr-2 elipsis d-block cursor" style={{fontSize:"0.75em"}}>#{transacToUpdate.uuid}</span></span>*/}
              </div>
            </div>
          </div>
          {transacToUpdate.type === 'BUNDLE' && (
            <div className="row no-gutters mb-2">
              <div className="col">
                <span className="d-block elipsis">Forfait</span>
                <span style={{ fontSize: '0.865em' }}>
                  <strong>{transacToUpdate.bundle_name}</strong>
                </span>
                <p
                  className="mb-0 pr"
                  style={{ fontSize: '0.765em', top: '-5px' }}
                >
                  {bundles.find((e) => e.name === transacToUpdate.bundle_name)
                    ? bundles.find(
                        (e) => e.id === parseInt(transacToUpdate.bundle_id),
                      ).description
                    : ''}
                </p>
              </div>
            </div>
          )}
          <div className="row no-gutters mb-3">
            <div className="col">
              <span className="d-block elipsis">
                {t('Number_to_be_credited')}
              </span>
              <span style={{ fontSize: '0.865em' }}>
                <strong>
                  {transacToUpdate.receiver_number
                    ? allService.chunk(transacToUpdate.receiver_number, 3, ' ')
                    : ''}
                </strong>
                <br />
              </span>
            </div>
            <div className="col text-right">
              <span className="d-block">{t('Amount')}</span>
              <span style={{ fontSize: '0.865em' }}>
                <strong>
                  {transacToUpdate.amount
                    ? allService.numberWithCommas(transacToUpdate.amount)
                    : ''}{' '}
                  Fcfa
                </strong>
              </span>
            </div>
          </div>
          <div className="row no-gutters mb-3">
            <div className="col">
              <span className="d-block">{t('Payer_number')}</span>
              <span style={{ fontSize: '0.865em' }}>
                <strong>
                  {transacToUpdate.payer_number
                    ? allService.chunk(transacToUpdate.payer_number, 3, ' ')
                    : ''}
                </strong>
              </span>
            </div>
            <div className="col text-right">
              <span className="d-block">{t('Payment_of')}</span>
              <span className="elipsis" style={{ fontSize: '0.865em' }}>
                <strong>
                  {transacToUpdate.created_at &&
                    new Date(transacToUpdate.created_at).toLocaleDateString(
                      'fr-FR',
                      {
                        weekday: 'long',
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                      },
                    )}
                </strong>
              </span>
            </div>
          </div>
          {transacToUpdate.validated_by_name &&
            transacToUpdate.validated_at &&
            transacToUpdate.status === 'COMPLETED' && (
              <div className="row no-gutters mb-3">
                <div className="col">
                  <span className="d-block elipsis">{t('In_charge')}</span>
                  <span style={{ fontSize: '0.865em' }}>
                    <strong>{transacToUpdate.validated_by_name}</strong>
                  </span>
                </div>
                <div className="col text-right">
                  <span className="d-block elipsis">{t('Validated_on')}</span>
                  <span className="elipsis" style={{ fontSize: '0.865em' }}>
                    <strong>
                      {transacToUpdate.validated_at &&
                        new Date(
                          transacToUpdate.validated_at,
                        ).toLocaleDateString('fr-FR', {
                          weekday: 'long',
                          year: 'numeric',
                          month: 'long',
                          day: 'numeric',
                        })}
                    </strong>
                  </span>
                </div>
              </div>
            )}
          {transacToUpdate.status === 'PENDING' && (
            <div className="row no-gutters mb-3">
              <div className="col">
                <span className="d-block">{t('Confirm_transction')}</span>
                <div className="d-inline-block">
                  <a data-reload className="cursor">
                    <label className="switch fl-r" title="Confirmer">
                      <input
                        onChange={() => validateTransac(transacToUpdate.uuid)}
                        type="checkbox"
                      />
                      <span className="slider round"></span>
                    </label>
                  </a>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {modalLoader && (
        <div
          className="modal modal-load text-center display"
          style={{
            display: `${modalLoader ? 'block' : 'none'}`,
            paddingTop: '120px',
            backgroundColor: 'rgba(255,255,255,0.6)',
            color: '#091e42',
          }}
        >
          <div className="w-100" style={{ marginTop: '8em' }}>
            <img
              src="assets/img/Eclipse-0.3s-800px.gif"
              alt="loader"
              className="mb-3"
              style={{ width: '140px' }}
            />
            <p class="fw-600" style={{ fontSize: '0.9em' }}>
              {t('processing')} ...
            </p>
          </div>
        </div>
      )}
      <Toaster toastOptions={{ position: 'bottom-center' }} />
    </React.Fragment>
  );
}
